import { FEEDBACK } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: FEEDBACK,
  params: {},
  okAction: 'reply',
  needFetchFillInfo: false,
  formatData(data) {
    data.feedbackId = this.params.feedbackId
    return data
  },
  view: {
    title: '回复问题反馈',
    labelPosition: 'right',
    content: [
      {
        $id: 'replyContent',
        $type: 'input',
        label: '回复内容',
        $el: {
          placeholder: '请输入回复内容',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '回复内容'
          }
        ]
      }
    ]
  }
}
